import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { Link } from 'react-router'
import { PERMISSIONS } from '@Const/permissions'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import PermissionCheck from '@Components/Utility/PermissionCheck'

const CatalogMobileSubLinks = observer(() => {
    const { rightsholderStore } = useContext(StoresContext)

    return (
        <div className="catalog-mobile-sub-links">
            <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_work_registration_status]}>
                <Link
                    to={Navigation.rightholder.registrationHistory.root(rightsholderStore.currentRightsholderId)}
                    className="bold"
                >
                    Registration History
                </Link>
            </PermissionCheck>
            <Link
                to={Navigation.rightholder.registrationDrafts.root(rightsholderStore.currentRightsholderId)}
                className="bold"
            >
                Registration Drafts
            </Link>
            <Link to={Navigation.rightholder.createWork.root(rightsholderStore.currentRightsholderId)} className="bold">
                Register Individual Work
            </Link>
        </div>
    )
})

export default CatalogMobileSubLinks
